import { convertFormDataToUrlSearchParams } from '@lib/utils/url'

export const sendConnectWithSales = async (formData: FormData) => {
  const submitUrl = 'https://go.grammarly.com/l/894581/2025-06-16/63gwd'
  const body = convertFormDataToUrlSearchParams(formData)

  if ('sendBeacon' in navigator) {
    // We are not processing response. The 'sendBeacon' API is faster than 'fetch' API, increasing form submission speed.
    return navigator.sendBeacon(submitUrl, body)
  }

  return await fetch(submitUrl, {
    body,
    method: 'post',
    mode: 'no-cors',
    credentials: 'include',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
}
